import React from "react";

export class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("UI crash:", error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="ui-error">
        <div className="max-w-md text-center">
          <h1 className="font-display font-black uppercase text-2xl text-white mb-2">Algo ha fallado</h1>
          <p className="text-white/50 text-sm mb-6">Se ha producido un error al mostrar esta página.</p>
          <button type="button" onClick={() => window.location.reload()} data-testid="ui-error-reload"
            className="btn-red text-white px-6 py-2.5 rounded-full font-semibold">Recargar</button>
        </div>
      </div>
    );
  }
}
